
<template>
    <div>
        <!--  票券列表选择弹框 -->
        <a-modal
            :title='title'
            :width="980"
            :visible="visible"
            :confirmLoading="loading"
            @cancel="closeModal"
            @ok="handleCreate"
            class="give-wrap"
            >
            <a-spin :spinning="spinning">
                <a-row class="mb16" v-if="goodType == 'both'">
                    <a-col :span="3">赠品类型：</a-col>
                    <a-col :span="16">
                        <a-radio-group
                        v-model="selectGoodType"
                        @change="changeGoodType"
                        >
                            <a-radio value="coupon">优惠券</a-radio>
                            <a-radio value="ticket">票券</a-radio>
                        </a-radio-group>
                    </a-col>
                </a-row>
                <div v-show="selectGoodType == 'ticket'">
                    <a-form :form="form" layout="inline">
                        <a-form-item label="ID">
                            <a-input placeholder="请输入" v-decorator="['ticketId']"></a-input>
                        </a-form-item>
                        <a-form-item label="票券内部标识">
                            <a-input placeholder="请输入" v-decorator="['name']"></a-input>
                        </a-form-item>
                        <a-form-item label="票券类型">
                            <a-select style="width: 180px" allowClear placeholder="请选择" v-decorator="['type']">
                                <a-select-option value="1">期限卡</a-select-option>
                                <a-select-option value="2">次卡</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item label="票券状态" class="mt16">
                            <a-select style="width: 180px" allowClear placeholder="请选择" v-decorator="['isOnShelves']">
                                <a-select-option :value="1">上架中</a-select-option>
                                <a-select-option :value="0">已下架</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item class="mt16">
                            <a-button @click="search" type="primary">筛选</a-button>
                            <a-button @click="handleReset">重置</a-button>
                        </a-form-item>
                    </a-form>
                    <a-table :pagination='pagination' @change="changePageNum" style="word-break:break-all;" class="mt16" :scroll="{ y: 360 }" bordered :columns="columns" :dataSource="dataSource" :rowSelection="{type: tableType, onChange: onSelectChange, selectedRowKeys: selectedTicketsRowKeys}" :rowKey="record => record.value" >
                        <span slot="type" slot-scope="a">{{['', '期限卡', '次卡'][a]}}</span>
                        <span slot="isOnShelves" slot-scope="a">{{['已下架', '上架中'][Number(a)]}}</span>
                        <span slot="shopSellList" slot-scope="a">{{a?a.map(e=>e.shopName).join('、'):'--'}}</span>
                    </a-table>
                    <div class="text-fail">您共选择了： {{selectedTicketsRowKeys.length || 0}} 个票券</div>
                </div>
                <div v-show="selectGoodType == 'coupon'">
                    <a-form :form="form" layout="inline">
                        <a-form-item label="优惠券名称">
                            <a-input placeholder="请输入" v-decorator="['name']" @pressEnter="search2()"></a-input>
                        </a-form-item>
                        <a-form-item label="适用类型">
                            <a-select style="width: 180px" allowClear placeholder="请选择" v-decorator="['suitType']" @select="search2()">
                                <a-select-option value="1">票券</a-select-option>
                                <a-select-option value="2">餐饮</a-select-option>
                                <a-select-option value="3">零售</a-select-option>
                                <a-select-option value="4">课程</a-select-option>
                                <a-select-option value="10">租赁</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item label="优惠券类型">
                            <a-select style="width: 180px" allowClear placeholder="请选择" v-decorator="['couponType']" @select="search2()">
                                <a-select-option value="1">满减券</a-select-option>
                                <a-select-option value="2">折扣券</a-select-option>
                                <a-select-option value="3">兑换券</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item label="优惠券状态" class="mt16">
                            <a-select style="width: 180px" allowClear placeholder="请选择" v-decorator="['status']" @select="search2()">
                                <a-select-option value="2">已生效</a-select-option>
                                <a-select-option value="1">未生效</a-select-option>
                                <a-select-option value="3">已失效</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item class="mt16">
                            <a-button @click="search2" type="primary">筛选</a-button>
                            <a-button @click="handleReset">重置</a-button>
                        </a-form-item>
                    </a-form>
                    <a-table :pagination='pagination' @change="changePageNum" style="word-break:break-all;" class="mt16" :scroll="{ y: 360 }" bordered :columns="columnsCoupon" :dataSource="dataSource" :rowSelection="{type: tableType, onChange: onSelectChange, selectedRowKeys: selectedTicketsRowKeys}" :rowKey="record => record.id" >
                        <span slot="suitType" slot-scope="a">{{["", "票券", "餐饮", "零售", "课程", "", "", "", "", "", "租赁"][a]}}</span>
                        <span slot="couponType" slot-scope="a">{{['', '满减券', '折扣券', "兑换券"][a]}}</span>
                        <span slot="status" slot-scope="a">{{["", '未生效', '已生效', "已失效"][a]}}</span>
                    </a-table>
                    <div class="mt8 text-fail">您共选择了： {{selectedTicketsRowKeys.length || 0}} 个优惠券</div>
                    <slot></slot>
                </div>
            </a-spin>
        </a-modal>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";

    /**
     * 票券选择弹框组件
     *
     * @prop {Boolean} visible 控制弹窗是否显示
     *
     * @func closeModal 通知父组件关闭弹窗
     *
     */
    const columns = [
        {
            title: "票券ID",
            dataIndex: "ticketTemplateId",
            width: 80,
        },
        {
            title: "票券内部标识",
            dataIndex: "name",
        },
        {
            title: "票券类型",
            dataIndex: "type",
            scopedSlots: { customRender: "type" },
            width: 150,
        },
        {
            title: "适用门店",
            dataIndex: "shopSellList",
            scopedSlots: { customRender: "shopSellList" },
            width: 150,
        },
        {
            title: "票券状态",
            dataIndex: "isOnShelves",
            scopedSlots: { customRender: "isOnShelves" },
            width: 150,
        },
        {
            title: "售卖价/元",
            dataIndex: "sellShowPrice",
            width: 150,
        }
    ];
    const columnsCoupon = [
        {
            title: "优惠券名称",
            dataIndex: "name",
        },
        {
            title: "适用类型",
            dataIndex: "suitType",
            scopedSlots: { customRender: "suitType" },
        },
        {
            title: "优惠券类型",
            dataIndex: "couponType",
            scopedSlots: { customRender: "couponType" },
        },
        {
            title: "优惠券状态",
            dataIndex: "status",
            scopedSlots: { customRender: "status" },
            width: 150,
        },
    ];
    export default {
        name: "ticket-list",
        zh: "门店票列表选择弹框组件",
        data() {
            return {
                title: "票券选择",
                form: this.$form.createForm(this),
                columns,
                columnsCoupon,
                selectGoodType: "coupon",
                dataSource: [],
                selectedTicketsRowKeys: [],
                shopList: [],
                dataSourceSearch: [],
                visible: false,
                ticketShopId: undefined,
                type: 1,
                flatData: [],
                flatCoupon: [],
                loading: false,
                spinning: false,
                dateString: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
            };
        },
        props: {
            goodType: {type: String, default: "both"},
            ticketList: {type: Array},
            couponList: {type: Array},
            selectedRowKeys: {type: Array},
            tableType: {type: String, default: "checkbox"},
        },
        computed: {...mapGetters(["shopId"])},
        watch: {
            visible(val) {
                this.flatData = this.$utils.deepClone(this.ticketList);
                this.flatCoupon = this.$utils.deepClone(this.couponList);
                this.pagination.current = 1;
                if (this.goodType == 'ticket') {
                    this.selectGoodType = this.goodType;
                    this.selectGoodType = "ticket";
                    this.title = '票券选择'
                } else if (this.goodType == 'both') {
                    this.selectGoodType = "coupon";
                    this.title = '赠品选择';
                }  else if (this.goodType == 'coupon') {
                    this.title = '发放优惠券';
                    this.selectGoodType = "coupon";
                    this.search2();
                }
                if(val) {
                    this.search()
                }
            },
        },
        methods: {
            changePageNum(page) {
                this.dataSource = this.dataSourceSearch.slice((page.current - 1) * this.pagination.pageSize, page.current * this.pagination.pageSize);
                this.pagination.current = page.current;
            },
            changeGoodType(e) {
                this.selectGoodType = e.target.value;
                if (this.selectGoodType == 'ticket') {
                    this.pagination.total = this.flatData.length;
                } else {
                    this.pagination.total = this.flatCoupon.length;
                }
                this.selectedTicketsRowKeys = [];
                this.handleReset();
            },
            handleReset () {
                if (this.selectGoodType !== 'ticket') {
                    this.selectGoodType = 'coupon';
                }
                this.pagination.total = 0;
                this.pagination.current = 1;
                this.dataSource = [];
                this.dateString = [];
                this.form.resetFields();
            },
            handleCreate() {
                let data = {
                    'ticket': this.flatData,
                    'coupon': this.flatCoupon,
                }
                if (!this.selectedTicketsRowKeys.length) {
                    this.$message.warning("请先选择")
                    return;
                }
                this.dateString = data[this.selectGoodType].filter(el => this.selectedTicketsRowKeys.find(item => el.value == item));
                this.$emit("confirmSelectTicket", this.dateString);
                if(this.goodType != 'coupon') {
                    this.closeModal()
                }
                // this.visible = false;
                // this.flatData = this.flatCoupon = [];
                // setTimeout(() => {
                //     this.loading = false;
                //     this.selectedTicketsRowKeys = [];
                //     this.handleReset();
                // }, 100);
            },
            onSelectChange(selectedRowKeys, dateString) {
                this.selectedTicketsRowKeys = selectedRowKeys;
            },
            closeModal() {
                this.form.resetFields();
                this.dataSource = this.flatData = [];
                this.visible = false;
                setTimeout(() => {this.selectedTicketsRowKeys = [];this.dateString=[];this.loading = false}, 100);
                this.$emit("closeModal");
            },
            search2() {
                let flatCoupon = this.flatCoupon;
                let { name, status, couponType, suitType } = this.form.getFieldsValue();
                this.dataSourceSearch = flatCoupon.filter(item => {
                    let couponNameCode = Boolean(name) ? new RegExp(name).test(String(item.name)) : true;
                    let suitTypeCode = suitType ? item.suitType == suitType : true;
                    let couponTypeCode = couponType ? item.couponType == couponType : true;
                    let stateCode = status ? item.status == status : true;
                    return (couponNameCode && couponTypeCode && stateCode && suitTypeCode);
                });
                this.dataSelect();
            },
            search() {
                let flatData = this.flatData;
                let { ticketId, name, type, isOnShelves } = this.form.getFieldsValue();
                this.dataSourceSearch = flatData.filter(item => {
                    let ticketNameCode = Boolean(name) ? new RegExp(name).test(String(item.name)) : true;
                    let ticketTypeCode = type ? item.type == type : true;
                    let ticketIdCode = ticketId ? item.ticketTemplateId.indexOf(ticketId) > -1 : true;
                    let stateCode;
                    if (typeof isOnShelves === 'undefined' || isOnShelves === null && !Boolean(isOnShelves)) {
                        stateCode = true;
                    } else {
                        stateCode = item.isOnShelves === Boolean(isOnShelves);
                    }
                    return (ticketNameCode && ticketTypeCode && stateCode && ticketIdCode);
                });
                this.dataSelect();
            },
            dataSelect() {
                this.pagination.current = 1;
                this.dataSource = this.dataSourceSearch.slice((this.pagination.current - 1) * this.pagination.pageSize, this.pagination.current * this.pagination.pageSize);
                this.pagination.total = this.dataSourceSearch.length;
            }
        },
        mounted() {
        }
    };
</script>

<style lang="scss">
.give-wrap .ant-modal-body {
    padding-bottom: 0;
}
</style>
